export const InfoboxIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="66"
            height="60"
            fill="none"
            viewBox="0 0 66 60"
        >
            <path
                fill="#6C3BFF"
                d="M16.1 39.9h34.4c.7 0 1.3-.5 1.3-1.3V21.4c0-.7-.5-1.3-1.3-1.3H16.1c-.7 0-1.3.5-1.3 1.3v17.2c0 .8.6 1.3 1.3 1.3zm1.1-17.2H49v14.6H17.2V22.7z"
            ></path>
            <path
                fill="#6C3BFF"
                d="M20.9 28.8h7.3c.7 0 1.3-.5 1.3-1.3 0-.7-.5-1.1-1.1-1.1H21c-.7 0-1.3.5-1.3 1.3.1.6.6 1.1 1.2 1.1zM33.1 28.8c.4 0 .5-.2.9-.4.2-.2.4-.5.4-.9s-.2-.5-.4-.9c-.5-.4-1.3-.4-1.8 0-.2.2-.4.5-.4.9s.2.5.4.9c.4.4.7.4.9.4zM45.5 31.3H25.8c-.7 0-1.3.5-1.3 1.3 0 .7.5 1.3 1.3 1.3h19.6c.7 0 1.3-.5 1.3-1.3-.1-.8-.6-1.3-1.2-1.3zM20.1 31.7c-.2.2-.4.5-.4.9s.2.5.4.9c.2.2.5.4.9.4s.5-.2.9-.4c.2-.2.4-.5.4-.9s-.2-.5-.4-.9c-.5-.7-1.4-.7-1.8 0zM33.1.6c-3.3 0-6.2 2.7-6.2 6.2s2.7 6.2 6.2 6.2c3.3 0 6.2-2.7 6.2-6.2S36.6.6 33.1.6zm0 9.8c-2 0-3.7-1.6-3.7-3.7S31 3 33.1 3c2 0 3.7 1.6 3.7 3.7s-1.5 3.7-3.7 3.7z"
            ></path>
            <path
                fill="#6C3BFF"
                d="M63.5 55.5c0 .7-.2 1.3-1 1.3H3.9c-.7 0-1.3-.5-1.3-1.3V11.7c0-.8-.6-1.3-1.3-1.3-.7 0-1.3.5-1.3 1.3V57c0 1.3 1.1 2.4 2.4 2.4h61.2c1.3 0 2.4-1.1 2.4-2.4V11.8c0-.7-.5-1.3-1.3-1.3-.7 0-1.3.5-1.3 1.3v39.1l.1 4.6z"
            ></path>
        </svg>
    );
};
